import { MAX_ZOOM, MIN_ZOOM, ZOOM_INCREMENT } from '../../common/constants';
import { ActionTypes } from '../actions';

export type IZoomState = number;
export const initialState: number = 1.5;

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const zoomReducer = (zoom: IZoomState = initialState, action: any) => {
  switch (action.type) {
    case ActionTypes.ZOOM_IN: {
      return zoom < MAX_ZOOM ? zoom + ZOOM_INCREMENT : zoom;
    }
    case ActionTypes.ZOOM_OUT: {
      return zoom > MIN_ZOOM ? zoom - ZOOM_INCREMENT : zoom;
    }
    default: {
      return zoom;
    }
  }
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default zoomReducer;
